import { FormItem } from '@main/datamap-types';
import { WorkflowConfig } from '@main/dsr-types';
import { mkType, type SchemaToType } from '@main/schema-utils';

export const PrivacyCenterWorkflowConfig = mkType({
  name: 'PrivacyCenterWorkflowConfig',
  comment: 'A subset of a workflow config, for the privacy center',
  fields: {
    id: {
      ...WorkflowConfig.fields.id,
    },
    title: {
      ...WorkflowConfig.fields.title,
    },
    subtitle: {
      ...WorkflowConfig.fields.subtitle,
    },
    description: {
      ...WorkflowConfig.fields.description,
    },
    action: {
      ...WorkflowConfig.fields.action,
    },
    subject: {
      ...WorkflowConfig.fields.subject,
    },
    regionList: {
      ...WorkflowConfig.fields.regionList,
    },
    formItems: {
      comment:
        'The form items that should be rendered when the data subject submits the request',
      list: true,
      type: FormItem,
    },
  },
});

/** Override type */
export type PrivacyCenterWorkflowConfig = SchemaToType<
  typeof PrivacyCenterWorkflowConfig
>;
